import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { fetchExternalUser, tableMmol, tablePress, tableUa, bindPhone } from '@/api';
import { invoke } from 'wecom-sidebar-jssdk';
import { Tabs, message, Table, Modal, Form, Input, Button } from 'ant-design-vue';
let ExternalUser = class ExternalUser extends Vue {
    constructor() {
        super(...arguments);
        this.externalUser = {
            avatar: '',
            nickname: '',
            phone: '',
            id: '',
        };
        this.activeKey = '1';
        this.centered = true;
        this.tableMmolData = {
            list: [],
            count: 0
        };
        this.tablePressData = {
            list: [],
            count: 0
        };
        this.tableUaData = {
            list: [],
            count: 0
        };
        this.time_select = [
            '', '早餐空腹', '餐后', '午餐前', '午餐后', '晚餐前', '晚餐后', '睡前', '凌晨'
        ];
        this.pagination = {
            current: 1,
            pageSize: 10,
            total: 0,
        };
        this.pagination1 = {
            current: 1,
            pageSize: 10,
            total: 0,
        };
        this.pagination2 = {
            current: 1,
            pageSize: 10,
            total: 0,
        };
        this.tableMmolDatacolumns = [
            {
                title: '测量时间',
                dataIndex: 'created_at',
                key: 'created_at',
            },
            {
                title: '',
                dataIndex: 'period_type_text',
                key: 'period_type_text',
            },
            {
                title: '数据',
                dataIndex: 'numeric',
                key: 'numeric',
            },
        ];
        this.tablePressDatacolumns = [
            {
                title: '测量时间',
                dataIndex: 'created_at',
                key: 'created_at',
            },
            {
                title: '低压',
                dataIndex: 'dbp',
                key: 'dbp',
            },
            {
                title: '高压',
                dataIndex: 'sbp',
                key: 'sbp',
            },
        ];
        this.tableUaDatacolumns = [
            {
                title: '测量时间',
                dataIndex: 'created_at',
                key: 'created_at',
            },
            {
                title: '数据',
                dataIndex: 'numeric',
                key: 'numeric',
            },
        ];
        this.open = false;
        this.userProfile = {
            phone: '',
        };
    }
    onClose() {
        this.open = false;
    }
    async openShow() {
        this.open = true;
    }
    async bindPhone() {
        const res = await invoke('getCurExternalContact', {});
        if (!res || !res.userId)
            return;
        const res1 = await bindPhone(res.userId, this.userProfile.phone);
        console.log(res1);
        if (res1.code !== 0) {
            message.error(res1.message);
        }
        else {
            this.externalUser.phone = this.userProfile.phone;
            message.success('绑定成功');
            this.open = false;
        }
    }
    async getExternalUserInfo() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.externalUser = await fetchExternalUser(res.userId);
        }
        catch (e) {
            message.error(e);
        }
    }
    async handleTableChange(pagination) {
        this.pagination = pagination;
        // 根据分页、筛选、排序的参数发起数据请求，更新数据
        await this.getTableMmol();
    }
    async getTableMmol() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.tableMmolData = await tableMmol(res.userId, this.pagination.current, this.pagination.pageSize);
            this.pagination.total = this.tableMmolData.count;
        }
        catch (e) {
            message.error(e);
        }
    }
    async handleTableChange1(pagination) {
        console.log(pagination);
        this.pagination1 = pagination;
        // 根据分页、筛选、排序的参数发起数据请求，更新数据
        await this.getTablePress();
    }
    async getTablePress() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.tablePressData = await tablePress(res.userId, this.pagination1.current, this.pagination1.pageSize);
            this.pagination1.total = this.tablePressData.count;
        }
        catch (e) {
            message.error(e);
        }
    }
    async handleTableChange2(pagination) {
        console.log(pagination);
        this.pagination2 = pagination;
        // 根据分页、筛选、排序的参数发起数据请求，更新数据
        await this.getTableUa();
    }
    async getTableUa() {
        try {
            const res = await invoke('getCurExternalContact', {});
            if (!res || !res.userId)
                return;
            console.log('外部联系人 ID', res.userId);
            this.tableUaData = await tableUa(res.userId, this.pagination2.current, this.pagination2.pageSize);
            this.pagination2.total = this.tableUaData.count;
        }
        catch (e) {
            message.error(e);
        }
    }
    async mounted() {
        await this.getExternalUserInfo();
        await this.getTableMmol();
        await this.getTablePress();
        await this.getTableUa();
    }
};
ExternalUser = __decorate([
    Component({
        name: 'ExternalUser',
        components: {
            'a-tabs': Tabs,
            'a-tab-pane': Tabs.TabPane,
            'a-table': Table,
            'a-modal': Modal,
            'a-form': Form,
            'a-form-item': Form.Item,
            'a-input': Input,
            'a-button': Button,
        }
    })
], ExternalUser);
export default ExternalUser;
